<template>
  <Banner
    :show="true"
    :text="$t('main.searchResult.banner.giveFeedback')"
    :button-text="$t('main.searchResult.banner.feedbackButton')"
    :button-link="feedbackBannerUrl"
    :bold-text="''"
  />
</template>

<script>
import Banner from './Banner.vue';

export default {
  components: {
    Banner
  },
  data() {
    return {
      feedbackBannerUrl:
        // eslint-disable-next-line max-len
        'https://feedback.vexels.com/trending?s=eyJmaWx0ZXJzIjpbeyJ0eXBlIjoiRklFTEQiLCJpcyI6IjBhYjFjODBhLTVkMjQtNDc5Mi05ZDUwLTQ0NThlYzRlZDRkZiJ9XX0%3D'
    };
  }
};
</script>
